import {
  type Branding,
  ChatAvailability,
  ClientName,
  I18nNamespace,
  TranslationLanguage,
} from "@hopper-b2b/types";
import { DateTimeFormatStyle } from "@hopper-i18n/formatter";
import { CANADA_PHONE_COUNTRY_CODE } from "@/utilities";

export const branding: Branding = {
  clientName: ClientName.RBC,
  default: TranslationLanguage["en-CA"],
  currencies: [
    {
      locale: "en-CA",
      code: "CAD",
      symbol: "$",
      highInflationCurrency: false,
    },
    {
      locale: "fr-CA",
      code: "CAD",
      symbol: "$",
      highInflationCurrency: false,
    },
  ],
  contactSupport: {
    aiChat: {
      variant: "extended",
    },
    chatAvailability: ChatAvailability.None,
    displaySupportNumber: "1-877-636-2870",
    supportNumber: "18776362870",
  },
  [I18nNamespace.translation]: {
    [TranslationLanguage["en-CA"]]: {
      portalName: "RBC Avion Rewards",
      preferredCountryCode: "CA",
      preferredAreaCode: CANADA_PHONE_COUNTRY_CODE,
      rewardsPriceFormatterKey: "{{amount}} pts",
      "@rewardsPriceFormatterKey": {
        description:
          "text - A number of points. 'pts' is an abbreviation for 'points'. PH({{amount}}|100|number of points)",
      },
      /** TODO: This should not be mandatory **/
      urls: {
        termsAndConditions: "https://hts.hopper.com/legal/avion-rewards-travel",
        airCfarTerms:
          "https://hts.hopper.com/en/legal/avion-rewards-travel-air-cfar",
        hotelCfarTerms:
          "https://hts.hopper.com/en/legal/avion-rewards-travel-hotel-cfar",
        privacyPolicy: "https://hts.hopper.com/legal/privacy-policy",
        helpCenterBaseUrl: "https://rbc-faq.hts.hopper.com/",
        govTravelAdvice: "https://travel.gc.ca/travelling/advisories",
        frenchTermsOfService:
          "https://hts.hopper.com/fr/legal/avion-rewards-travel",
        benefitsFromAirline:
          "https://hts.hopper.com/legal/hts-passenger-rights-overview",
        htsAddOns: "https://hts.hopper.com/legal/what-are-hts-add-ons",
        disruptionTerms:
          "https://hts.hopper.com/legal/avion-rewards-travel-dafar",
        rewardsTerms:
          "https://www.avionrewards.com/retailers/termsconditions/rbc_rewards_terms_119753.pdf",
        privacyStatement: "https://www.rbc.com/privacysecurity/ca/index.html",
        contactSupportUrl:
          "https://rbc-faq.hts.hopper.com/en_us/how-do-i-contact-customer-support-rJBbbmXYx",
        pricePredictionTerms:
          "https://hts.hopper.com/legal/avion-rewards-travel#12-price-predictions-price-watch-notifications-and-sort-order",
      },
      calendarMonthFormatStyle: DateTimeFormatStyle.Custom({
        month: "long",
        year: "numeric",
      }),
      calendarDayOfWeekFormatStyle: DateTimeFormatStyle.Custom({
        weekday: "short",
      }),
    },
    [TranslationLanguage["fr-CA"]]: {
      portalName: "RBC Avion Rewards",
      preferredCountryCode: "CA",
      preferredAreaCode: CANADA_PHONE_COUNTRY_CODE,
      rewardsPriceFormatterKey: "{{amount}} pts",
      "@rewardsPriceFormatterKey": {
        description:
          "text - A number of points. 'pts' is an abbreviation for 'points'. PH({{amount}}|100|number of points)",
      },
      /** TODO: This should not be mandatory **/
      urls: {
        termsAndConditions:
          "https://hts.hopper.com/fr/legal/avion-rewards-travel",
        airCfarTerms:
          "https://hts.hopper.com/fr/legal/avion-rewards-travel-air-cfar",
        hotelCfarTerms:
          "https://hts.hopper.com/fr/legal/avion-rewards-travel-hotel-cfar",
        privacyPolicy: "https://hts.hopper.com/fr/legal/privacy-policy",
        helpCenterBaseUrl: "https://rbc-faq.hts.hopper.com/lang/fr/",
        govTravelAdvice: "https://voyage.gc.ca/voyager/avertissements",
        frenchTermsOfService:
          "https://hts.hopper.com/fr/legal/avion-rewards-travel",
        benefitsFromAirline:
          "https://hts.hopper.com/legal/hts-passenger-rights-overview",
        htsAddOns: "https://hts.hopper.com/fr/legal/what-are-hts-add-ons",
        disruptionTerms:
          "https://hts.hopper.com/legal/avion-rewards-travel-dafar",
        rewardsTerms:
          "https://www.avionrewards.com/fr/retailers/conditions/rbc_recompenses_conditions_119754.pdf",
        privacyStatement: "https://www.rbc.com/rensperssecurite/ca/index.html",
        contactSupportUrl:
          "https://rbc-faq.hts.hopper.com/fr/comment-puis-je-contacter-le-service-de-soutien-rJBbbmXYx",
        pricePredictionTerms:
          "https://hts.hopper.com/fr/legal/avion-rewards-travel#12-previsions-de-prix-alertes-de-prix-et-ordre-de-tri",
      },
      calendarMonthFormatStyle: DateTimeFormatStyle.Custom({
        month: "long",
        year: "numeric",
      }),
      calendarDayOfWeekFormatStyle: DateTimeFormatStyle.Custom({
        weekday: "short",
      }),
    },
  },
  supportedLanguages: [
    { key: TranslationLanguage["en-CA"], name: "English", label: "CA English" },
    { key: TranslationLanguage["fr-CA"], name: "French", label: "CA French" },
  ],
  merchantPayments: "",
  showAIChat: true,
};
